import { fallAccessoriesSearchProducts } from "../../../data/entity_sets/fallAccessoriesSearchProducts";

export interface MockReorderedProduct {
  id: string;
  name: string;
  brandName: string;
  imageUrl: string;
  lastOrderedAt: string;
}

const MAX_REORDERED_RESULTS = 2;
export const MIN_QUERY_LENGTH = 3;

/**
 * Previously-ordered dates for the typeahead's reorder section. Cycled over the
 * fall-accessories catalogue so the section stays on-theme with the search
 * results instead of carrying the pantry products from the source prototype.
 */
const LAST_ORDERED_DATES = [
  "2026-03-21",
  "2026-02-14",
  "2026-01-29",
  "2025-12-05",
  "2025-11-02",
  "2025-09-18",
  "2025-08-04",
  "2025-06-30",
];

export const MOCK_REORDERED_PRODUCTS: MockReorderedProduct[] =
  fallAccessoriesSearchProducts.slice(0, 8).map((product, index) => ({
    id: product.token,
    name: product.name,
    brandName: product.brandName,
    imageUrl: product.imageUrl,
    lastOrderedAt: LAST_ORDERED_DATES[index % LAST_ORDERED_DATES.length],
  }));

export const filterReorderedProducts = (
  query: string,
  products: MockReorderedProduct[]
): MockReorderedProduct[] => {
  const normalized = query.trim().toLowerCase();
  if (normalized.length < MIN_QUERY_LENGTH) {
    return [];
  }
  const matches = products.filter((product) =>
    product.name.toLowerCase().includes(normalized)
  );
  matches.sort((firstProduct, secondProduct) =>
    secondProduct.lastOrderedAt.localeCompare(firstProduct.lastOrderedAt)
  );
  return matches.slice(0, MAX_REORDERED_RESULTS);
};

const MONTH_ABBREVIATIONS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const formatOrderedDate = (isoDate: string, now: Date): string => {
  const orderedDate = new Date(`${isoDate}T00:00:00`);
  const month = MONTH_ABBREVIATIONS[orderedDate.getMonth()];
  const day = orderedDate.getDate();
  if (orderedDate.getFullYear() === now.getFullYear()) {
    return `${month} ${day}`;
  }
  return `${month} ${day}, ${orderedDate.getFullYear()}`;
};
